<template>
 <a :href="url" class="list-group-item list-group-item-action
  border-top rounded-lg d-flex align-items-start my-2" style="min-height: 80px">
    <span class="material-icons mr-2"> {{ postStatus }} </span>
    <div class="d-flex flex-column mr-2">
      <h5 class="font-weight-normal title-font-size">{{ data.name }}</h5>
      <p class="text-muted mb-0 mt-auto">
        <small>{{ dateFormatYMD(data.opened_at.datetime) }}</small>
      </p>
    </div>
    <span class="px-md-5 px-4 py-2 rounded-lg text-nowrap
      bg-light ml-auto tag-font-size">{{ tag }}</span>
  </a>
</template>

<script>
export default {
  props: {
    url: String,
    data: Object,
    postStatus: String,
    tag: String,
  },
  data() {
    return {

    };
  },
};
</script>
<style>
.tag-font-size {
  font-size: 1rem;
}
@media (max-width: 768px) {
  .tag-font-size {
    font-size: 0.75rem
  }
}
.title-font-size {
  font-size: 1.25rem;
}
@media (max-width: 768px) {
  .title-font-size {
    font-size: 1rem;
  }
}
</style>
